import { getAppState } from "../state";

export function getTwistMigrationUrl(url, language) {
  if (!url.includes("[lang]")) {
    language = "en";
  }
  return url.replace("[lang]", language);
}

export function isTwistMigrationEnabled() {
  const remoteConfig = getAppState().remoteConfig?.twist_to_sp_migration;
  if (!remoteConfig?.enabled) {
    return false;
  }

  const countries = remoteConfig.countries;
  const currentCountry = getAppState().country;

  if (!countries || !Array.isArray(countries) || countries.length === 0) {
    return false;
  }

  return countries.some(c => c.toLowerCase() === currentCountry?.toLowerCase()) || false;
}
